/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreditCardCapture/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Error from './Error/index'
import Loading from './Loading/index'
import React from 'react'
import Ready from './Ready/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function CreditCardCapture({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/CreditCardCapture"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Loading'
let creditCardCaptureStatusValueData = fromData.useDataFormat({ viewPath,
context: 'credit_card_capture',
path: 'status',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: creditCardCaptureStatusValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Ready'}>
<Ready
  viewPath={`${viewPath}/Ready`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}